module.exports = __webpack_public_path__ + "static/media/ic_copy.fdc4acfd.svg";